/**
 * Granular powers for organizers (Firestore-rol `organizer`, in de UI: beheerder).
 * Owners en board houden in de hub volledige toegang; legacy beheerders zonder `capabilities` ook.
 */
export type EntityMemberCapabilities = {
  canStartMeeting: boolean;
  canManageOverlays: boolean;
  canManageGuests: boolean;
  canInviteMembers: boolean;
  canEditBranding: boolean;
  canManageAgenda: boolean;
  canManageGrowth: boolean;
  canManageSessions: boolean;
};

export const CAPABILITY_KEYS: (keyof EntityMemberCapabilities)[] = [
  'canStartMeeting',
  'canManageOverlays',
  'canManageGuests',
  'canInviteMembers',
  'canEditBranding',
  'canManageAgenda',
  'canManageGrowth',
  'canManageSessions',
];

export const DEFAULT_ORGANIZER_CAPABILITIES: EntityMemberCapabilities = {
  canStartMeeting: true,
  canManageOverlays: true,
  canManageGuests: true,
  canInviteMembers: true,
  canEditBranding: true,
  canManageAgenda: true,
  canManageGrowth: true,
  canManageSessions: true,
};

/**
 * Lezen van opgeslagen capabilities: alleen expliciet `false` wijst af.
 * Ontbrekende velden (oudere uitnodigingen met alleen de eerste rechten) gelden als true.
 */
export function strictCapabilities(stored: Partial<EntityMemberCapabilities>): EntityMemberCapabilities {
  const out = {} as EntityMemberCapabilities;
  for (const k of CAPABILITY_KEYS) {
    out[k] = stored[k] !== false;
  }
  return out;
}

export function resolveHubCapabilities(
  role: string | undefined,
  stored: Partial<EntityMemberCapabilities> | null | undefined
): EntityMemberCapabilities {
  if (role === 'owner' || role === 'board') {
    return { ...DEFAULT_ORGANIZER_CAPABILITIES };
  }
  if (role === 'organizer') {
    if (stored == null) return { ...DEFAULT_ORGANIZER_CAPABILITIES };
    return strictCapabilities(stored);
  }
  const none = {} as EntityMemberCapabilities;
  for (const k of CAPABILITY_KEYS) none[k] = false;
  return none;
}
